import {
    AUTH_ERROR,
    AUTH_SUCCESS,
    DOWNLOADED,
    ERROR_MESSAGE,
    LOADED,
    LOADING,
    PERCENT,
    SUCCESS_MESSAGE,
    TOTAL_SIZE,
    VALIDATION_AUTH_ERROR,
    VALIDATION_ERROR,
} from './types';

import history from '../history';
import api from './apis';
import axios from 'axios';


// ========================Create Batch=========================
export const createBatch = (data) => async (dispatch) => {
  
    // console.log(data)
      dispatch({type: LOADING});
      const object = {
        batch_no : data.batch_no,
        title : data.title,
        active : data.active,
        price : data.price,
        product : data.product.split('.')[1],
        weight : data.weight,
        weight_unit : data.weight_unit,
        life_time : data.life_time,
        manufacture_date : data.manufacture_date,
        code_type : data.code_type,
        code_count : data.code_count,
        file_type : data.file_type,
      };
      if(data.expiry_date){
        object.expire_date = data.expiry_date
      }
      
      try {
        const response = await api(localStorage.getItem("token")).post(
          "batch/code/generate",
          { ...object }
        );
    
        if (response.status === 201) {
          
        dispatch({type: LOADED});
        dispatch({ type: SUCCESS_MESSAGE, payload: response.data.message });
        return response.status
        }
      } catch (err) {
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 451)
            {
              history.push('/pending-verification')
            }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/notFound') });
          dispatch({type: LOADED});
      }
    };

// ========================Get Active Products==========================
export const getActiveProducts = () => async (dispatch) => {
  
    dispatch({type: LOADING});
    try {
      const response = await api(localStorage.getItem("token")).get(`/product/active`);
      if(response.status === 200){
            dispatch({type: LOADED});
            return response.data.products
      }
      
      
    } catch (err) {
      /* =============Start========== */
      if(err?.response?.status === 451)
        {
            history.push('/pending-verification')
        }
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/notFound') });
        dispatch({type: LOADED});
      /* ===========End============*/}
  };

// ========================Get Batches==========================
export const getBatches = (page,title,active,batch_no) => async (dispatch) => {
  
    dispatch({type: LOADING});
    try {
      const response = await api(localStorage.getItem("token")).get(
        `/batch?p=${page == undefined ? 1 : page}&title=${title ? title : ''}&batch_no=${batch_no ? batch_no : ''}&active=${active ? active : ''}`
      );
      if(response.status === 200){
            dispatch({type: LOADED});
        return response.data
      }
      
      
    } catch (err) {
      /* =============Start========== */
      if(err?.response?.status === 451)
        {
            history.push('/pending-verification')
        }
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/notFound') });
        dispatch({type: LOADED});
      /* ===========End============*/}
  };

// ========================Get batche details==========================
export const getBatchDetails = (batch_no) => async (dispatch) => {
  
    dispatch({type: LOADING});
    try {
      const response = await api(localStorage.getItem("token")).get(
        `/batch/detail?batch=${batch_no}`
      );
      if(response.status === 200){
            dispatch({type: LOADED});
        return response.data.batch
      }
      
      
    } catch (err) {
      /* =============Start========== */
      if(err?.response?.status === 451)
        {
            history.push('/pending-verification')
        }
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/notFound') });
        dispatch({type: LOADED});
      /* ===========End============*/}
  };

  // ==========File download================
    
export const fileDownloader = (batch) => async (dispatch) => {
  dispatch({ type: LOADING });
  try{
    const response = await axios(`${process.env.REACT_APP_API_BASE_URL}/client/file/generate/download?batch=${batch}`,
        {
          headers: {
            'authorization': `Bearer ${localStorage.getItem("token")}`
            },
            method: 'GET',
            responseType: 'blob',
            onDownloadProgress:  (progressEvent) => {
            
                            const len = progressEvent.total;
              
                            let cur = 0;
                            const total = (len / 1048576).toFixed(2); 
              
                            cur += progressEvent.loaded;
                            let loading = (100.0 * cur / len).toFixed(0)
                            let tot = (cur / 1048576).toFixed(2)
                            
                            dispatch({ type: TOTAL_SIZE, payload: total});
                            dispatch({ type: DOWNLOADED, payload: tot});
                            dispatch({ type: PERCENT, payload: loading});
                            if(loading == 100){
                              
                            dispatch({ type: TOTAL_SIZE, payload: null});
                            dispatch({ type: DOWNLOADED, payload: null});
                            dispatch({ type: PERCENT, payload: null});
                            }
                      
                          }
          }
        );
        
    if(response.status === 200 ) {
      // FileDown
      dispatch({ type: LOADED });
      const url = window.URL.createObjectURL(new Blob([response.data]),);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `Fakebuzz-${batch}.zip`,
      );
      // Append to html link element page
      document.body.appendChild(link);
      // Start download
      link.click();
      // Clean up and remove the link
      link.parentNode.removeChild(link);
    }
  }
  catch( err ){
      if(err?.response?.status === 451)
        {
          history.push('/pending-verification')
        }
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        
        if(err.message == 'Network Error')
        {
            history.push('/maintenance')
            return
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
}
// export const fileDownloader = (batch) => async (dispatch) => {
//   dispatch({ type: LOADING });

  
//   try{
//     const response = await axios(`${process.env.REACT_APP_API_BASE_URL}/client/file/generate/download?batch=${batch}`,
//         {
//           headers: {
//             'authorization': `Bearer ${localStorage.getItem("token")}`
//             },
//             method: 'GET',
//             responseType: 'blop',

//             onDownloadProgress:  (progressEvent) => {
            
//               const len = progressEvent.total;

//               let cur = 0;
//               const total = (len / 1048576).toFixed(2); 

//               cur += progressEvent.loaded;
//               let loading = (100.0 * cur / len).toFixed(0)
//               let tot = (cur / 1048576).toFixed(2)
              
//               dispatch({ type: TOTAL_SIZE, payload: total});
//               dispatch({ type: DOWNLOADED, payload: tot});
//               dispatch({ type: PERCENT, payload: loading});
//               if(loading == 100){
                
//               dispatch({ type: TOTAL_SIZE, payload: null});
//               dispatch({ type: DOWNLOADED, payload: null});
//               dispatch({ type: PERCENT, payload: null});
//               }
        
//             }
        
//         } 
//       );


        
//     if(response.status === 200 ) {
//       // FileDown
//       dispatch({ type: LOADED });
//       const url = window.URL.createObjectURL(new Blob([response.data]),);
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute(
//         'download',
//         `Fakebuzz-${batch}.xlsx`,
//       );
//       // Append to html link element page
//       document.body.appendChild(link);
//       // Start download
//       link.click();
//       // Clean up and remove the link
//       link.parentNode.removeChild(link);
//     }
//   }
//   catch( err ){

//       if(err?.response?.status === 451)
//         {
//           history.push('/pending-verification')
//         }
//       /* =============Start========== */
//         if(err?.response?.status === 422){
//           err.response.data.errors.map(item => {
//               dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
//           })
//         }
//         if(err?.response?.status === 401 || err?.response?.status === 403 ){
//             dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
//             localStorage.clear();
//             history.push('/login')
//         }
//         dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
//         dispatch({type: LOADED});
//       /* ===========End============*/
//     }
// }